import React, { Fragment } from 'react'

const RestoreButton = React.memo(
  ({ restoreFromSpam, restoreFromDeleted, isDeleted = true, isSpam }) => {
    return (
      <div className="restore">
        <a
          className="menu-button label"
          onClick={isSpam ? restoreFromSpam : restoreFromDeleted}
        >
          <span className="label">
            {isSpam && <Fragment>Mark as not spam & reopen</Fragment>}
            {isDeleted && <Fragment>Remove from trash & reopen</Fragment>}
          </span>
        </a>
      </div>
    )
  }
)

export default RestoreButton
